package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class ReferenceState(
    val id: String,
    nom: String = "",
    entreprise: String = "",
    ville: String = "",
    telephone: String = "",
    mail: String = ""
) {
    var nom by mutableStateOf(nom)
    var entreprise by mutableStateOf(entreprise)
    var ville by mutableStateOf(ville)
    var telephone by mutableStateOf(telephone)
    var mail by mutableStateOf(mail)
}